/* Luxuntique 2026 — product page helpers
   Size buttons in the variant picker show UK first (EU underneath), using the brand chart
   that the size guide puts on the page. Re-applied whenever the picker re-renders. */
(function () {
  if (window.__luxProduct) return;
  window.__luxProduct = true;

  function num(v) {
    if (v == null) return NaN;
    var m = String(v).trim().match(/^(\d+(?:\.\d+)?)(?:\s+(\d)\/(\d))?/);
    if (!m) return NaN;
    var n = parseFloat(m[1]);
    if (m[2]) n += parseInt(m[2], 10) / parseInt(m[3], 10);
    return n;
  }
  var chart = null, cU = -1, cE = -1;
  function loadChart() {
    if (chart) return true;
    var el = document.querySelector('.lux-sf__data');
    if (!el) return false;
    try { chart = JSON.parse(el.textContent).chart; } catch (e) { chart = null; }
    if (!chart || !chart.headers) { chart = null; return false; }
    chart.headers.forEach(function (h, i) {
      var u = String(h).toUpperCase();
      if (cU < 0 && u.indexOf('UK') === 0) cU = i;
      if (cE < 0 && u.indexOf('EU') === 0) cE = i;
    });
    return cU >= 0 && cE >= 0;
  }
  function ukFor(eu) {
    var v = num(eu), rows = chart.rows || [], i;
    if (isNaN(v)) return '';
    for (i = 0; i < rows.length; i++) if (num(rows[i][cE]) === v) return rows[i][cU];
    for (i = 0; i < rows.length; i++) if (Math.floor(num(rows[i][cE]) * 2) / 2 === v) return rows[i][cU];
    var best = '', d = 9;
    for (i = 0; i < rows.length; i++) { var x = Math.abs(num(rows[i][cE]) - v); if (x < d) { d = x; best = rows[i][cU]; } }
    return d <= 0.5 ? best : '';
  }

  /* Sticky bar and any other copies of the button: "Add to cart" reads "Add to bag" */
  function bagLabels() {
    document.querySelectorAll('.add-to-cart-text, .sticky-add-to-cart__button').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (/add to cart/i.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/add to cart/i, 'Add to bag');
      }
    });
  }

  /* The size guide link sits at the top right of the size picker (design board); Find my size
     has its own panel above Add to bag (snippets/size-guide.liquid).
     The buttons are copies; the size guide script listens on the whole page, so they work the same. */
  function placeSizeTools() {
    var row = document.querySelector('.lux-sg > .lux-sg__row');
    if (!row) return;
    document.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !/size/i.test(legend.textContent)) return;
      if (fs.querySelector(':scope > .lux-size-tools')) return;
      var tools = document.createElement('div');
      tools.className = 'lux-size-tools';
      row.querySelectorAll('.size-guide-trigger').forEach(function (btn) {
        tools.appendChild(btn.cloneNode(true));
      });
      fs.classList.add('lux-size-picker', 'lux-size-picker--tools');
      fs.appendChild(tools);
      document.documentElement.classList.add('lux-sg-in-picker');
    });
  }

  function relabel() {
    bagLabels();
    placeSizeTools();
    if (!loadChart()) return;
    document.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !/size/i.test(legend.textContent)) return;
      fs.classList.add('lux-size-picker');
      var selected = '';
      fs.querySelectorAll('label.variant-option__button-label').forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        var text = label.querySelector('.variant-option__button-label__text');
        if (!input || !text) return;
        var eu = input.value, uk = ukFor(eu);
        if (input.checked) selected = uk ? 'UK ' + uk : 'EU ' + eu;
        if (text.dataset.luxFor === eu) return;
        text.dataset.luxFor = eu;
        if (uk) text.innerHTML = '<span class="lux-v-main">UK ' + uk + '</span><span class="lux-v-sub">EU ' + eu + '</span>';
      });
      var want = 'Size' + (selected ? ' — ' + selected + ' selected' : '');
      if (legend.dataset.luxText !== want) { legend.dataset.luxText = want; legend.textContent = want; }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; relabel(); });
  }
  function boot() {
    relabel();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
